import CreateResellerButton from "../../resellers/CreateResellerButton";
import {
  ActionIcon,
  Grid,
  Group,
  Skeleton,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { IconBuildingStore, IconRefresh } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { getProfile } from "../../../../api/UserAPI";
import { useUIStore } from "../../../../stores/UIStore";
import ResellerItem from "./ResellerItem";
import { useProfileStore } from "../../../../stores/UserStore";
import { useNavigate } from "react-router-dom";
import ResellersListingAdmin from "./ResellersListingAdmin";
import { useLanguage } from "../../../../stores/LanguageStore";

const ResellersListing = () => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  const handleRefresh = () => {
    setLoading(true);
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (items.length === 0 && !loading && profile?.level !== "admin") {
      navigate("/resellers/create");
    }
  }, [items.length, loading, navigate, profile?.level]);

  useEffect(() => {
    if (loading) {
      let f = getProfile;
      f()
        .then((res) => {
          return setItems(res.data.user_profile.resellers);
        })
        .finally(() => setLoading(false));
    }
  });

  useEffect(() => {
    let locked = useUIStore.getState().pinnedNavbar;
    if (!locked) {
      useUIStore.getState().setNavbarClosed(true);
      useUIStore.getState().setCampaignOpened(false);
    }
  }, []);

  return (
    <Stack gap={0} pr={48} pt={32} px={64} pb={16}>
      <Title order={2} ff={"Inter"} ta={"center"} w={"100%"}>
        <span style={{ fontSize: 24, marginRight: 8 }}>🎉</span>{" "}
        {lang.white_labels.welcome} {profile?.first_name} !
      </Title>

      <Group my={32}>
        <ThemeIcon size={"xl"} radius={"md"} variant="filled" color="primary">
          <IconBuildingStore size={32} />
        </ThemeIcon>

        <Text fw={700} fz={24}>
          {lang.white_labels.title}
        </Text>
        <ActionIcon
          onClick={handleRefresh}
          mr={"auto"}
          variant="subtle"
          size="sm"
          w={38}
          h={38}
          p={0}
        >
          <IconRefresh size={22} />
        </ActionIcon>

        <CreateResellerButton />
      </Group>

      {loading ? (
        <Skeleton radius={"md"} height={300} width={"100%"} />
      ) : (
        <Grid gutter={"lg"}>
          {items.map((item) => (
            <Grid.Col key={item.id} span={3}>
              <ResellerItem item={item} />
            </Grid.Col>
          ))}
        </Grid>
      )}

      {profile?.level === "admin" && <ResellersListingAdmin />}
    </Stack>
  );
};

export default ResellersListing;
